<div *ngIf="!helpersService.noFooter" id="footer" class="container-fluid footer">
    <div class="text-center" [innerHTML]="'footer-impressum' | translate"></div>
    <!-- OneTrust Cookies Settings button start -->
    <!-- <button id="ot-sdk-btn" class="ot-sdk-show-settings">Cookie Settings</button> -->
    <!-- OneTrust Cookies Settings button end -->
    <!-- <p class="m-0 transparent-version">v{{appVersion}}</p> -->
</div>